module.exports = __webpack_public_path__ + "images/category_lp/smartwatch/store_images/4_16d26b10efc65afc216aeffbb779d703.png";